// FETCH ALL DYEING INWARD DETAILS
export const FETCH_DYEING_INWARD_DETAILS_REQUEST_DK = 'FETCH_DYEING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_DYEING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_DYEING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_DYEING_INWARD_DETAILS_FAILURE_DK = 'FETCH_DYEING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL DYEING INWARD DETAILS
export const FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE DYEING INWARD DETAILS
export const CREATE_DYEING_INWARD_DETAILS_REQUEST_DK = 'CREATE_DYEING_INWARD_DETAILS_REQUEST_DK';
export const CREATE_DYEING_INWARD_DETAILS_SUCCESS_DK = 'CREATE_DYEING_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_DYEING_INWARD_DETAILS_FAILURE_DK = 'CREATE_DYEING_INWARD_DETAILS_FAILURE_DK';

// UPDATE DYEING INWARD DETAILS
export const UPDATE_DYEING_INWARD_DETAILS_REQUEST_DK = 'UPDATE_DYEING_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_DYEING_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_DYEING_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_DYEING_INWARD_DETAILS_FAILURE_DK = 'UPDATE_DYEING_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF DYEING INWARD DETAILS
export const FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM DYEING_INWARD DETAILS
export const FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE_DK';

// DELETE DYEING INWARD DETAILS
export const DELETE_DYEING_INWARD_DETAILS_REQUEST_DK = 'DELETE_DYEING_INWARD_DETAILS_REQUEST_DK';
export const DELETE_DYEING_INWARD_DETAILS_SUCCESS_DK = 'DELETE_DYEING_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_DYEING_INWARD_DETAILS_FAILURE_DK = 'DELETE_DYEING_INWARD_DETAILS_FAILURE_DK';

export const RESET_DYEING_INWARD_DETAILS_INFO_DK = 'RESET_DYEING_INWARD_DETAILS_INFO_DK';

export const CREATE_DYEING_INWARD_DETAILS_FORM_DK = 'CREATE_DYEING_INWARD_DETAILS_FORM_DK';

export const UPDATE_DYEING_INWARD_DETAILS_FORM_DK = 'UPDATE_DYEING_INWARD_DETAILS_FORM_DK';

export const DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK = 'DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK';
